export const EFP_WEB_BREAK_POINT = 1024

export function checkIfMobileLayout(): boolean {
  return window.innerWidth < EFP_WEB_BREAK_POINT
}
